module.exports = __webpack_public_path__ + "img/ios.885e0aae.png";